module.exports = __webpack_public_path__ + "img/pay-bills-icon.b831f35c.svg";